import { apiClient } from './apiConfig';

export interface HevyStatus {
  connected: boolean;
  is_active?: boolean;
  last_synced_at?: string | null;
}

export interface HevySyncResult {
  status: string;
  workouts_fetched: number;
  routines_fetched: number;
  workout_sessions_created: number;
  workout_sessions_skipped: number;
  strength_sessions_created: number;
  strength_sessions_skipped: number;
  routines_created: number;
  routines_updated: number;
}

export interface HevyRoutineSet {
  index: number;
  type: string;
  weight_kg: number | null;
  reps: number | null;
  duration_seconds: number | null;
  distance_meters: number | null;
}

export interface HevyRoutineExercise {
  index: number;
  title: string;
  notes: string;
  sets: HevyRoutineSet[];
  rest_seconds: number;
}

export interface HevyRoutine {
  id: number;
  hevy_routine_id: string;
  title: string;
  exercises: HevyRoutineExercise[];
  exercise_count: number;
  hevy_updated_at: string | null;
}

export const hevyAPI = {
  getStatus: async (): Promise<HevyStatus> => {
    const response = await apiClient.get('/api/hevy/status/');
    return response.data;
  },

  saveConnection: async (apiKey: string): Promise<{ status: string; connected: boolean }> => {
    const response = await apiClient.post('/api/hevy/save/', { api_key: apiKey });
    return response.data;
  },

  sync: async (days: number = 7): Promise<HevySyncResult> => {
    const response = await apiClient.post('/api/hevy/sync/', { days });
    return response.data;
  },

  disconnect: async (): Promise<{ status: string }> => {
    const response = await apiClient.post('/api/hevy/disconnect/');
    return response.data;
  },

  getRoutines: async (): Promise<HevyRoutine[]> => {
    const response = await apiClient.get('/api/hevy-routines/');
    return response.data.results ?? response.data;
  },
};
